/* eslint-disable @next/next/no-img-element */
import classNames from '@sindresorhus/class-names';
import Link from 'next/link';

import {Icon} from '@web-catalog/ui-kit/Icon';

import styles from './Chip.module.scss';

type Props = {
  active?: boolean;
  linkTo: string;
  label: string;
  iconComponent?: any;
  iconSrc?: string;
  iconColorVariant?: string;
  testId?: string;
  onClick: (active: boolean) => void;
};

export const Chip = ({
  linkTo,
  label,
  iconComponent,
  iconSrc,
  iconColorVariant,
  active,
  testId,
  onClick,
}: Props) => {
  return (
    <Link
      href={linkTo}
      prefetch={false}
      className={classNames(styles.root, active && styles.active)}
      onClick={() => onClick(!!active)}
      data-testid={testId}
    >
      {iconComponent && (
        <Icon svg={iconComponent} className={styles.iconComponent} />
      )}
      {iconSrc && (
        <img
          alt=""
          aria-hidden="true"
          src={iconSrc}
          loading="lazy"
          className={classNames(
            styles.icon,
            active && styles.activeIcon,
            !active &&
              iconColorVariant &&
              (styles as Record<string, string>)[iconColorVariant],
          )}
        />
      )}
      {label}
    </Link>
  );
};
